module.exports = __webpack_public_path__ + "0c9ba7f671c65892816349fd261db00c.pdf";